import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getIsBatchDetailsPage } from '../../../../store/batches/batches.helpers';
import { labelQuePrintOrderSummary } from '../../../../store/label-que/label-que.actions';
import { printOrderSummary } from '../../../../store/printing/print.actions';
import Global from '../../../../store/global-selectors';
import { emptyObject } from 'ui-components/default-props/empty';
import { useGetPrintSettingsForDocumentType } from '../../../../hooks/use-get-print-settings-for-document-type';
import { DocumentType } from '../../../../enums/document-type';

export const useOrderSummary = ({ fulfillmentPlans }) => {
  const dispatch = useDispatch();
  const isOnBatchesGrid = getIsBatchDetailsPage();
  const isDisabled = !isOnBatchesGrid && fulfillmentPlans.length === 0;
  const fulfillmentPlanIds = useMemo(() => fulfillmentPlans.map(({ fulfillmentPlanId }) => fulfillmentPlanId), [fulfillmentPlans]);
  const { fulfillmentPlanSetId } = useSelector(Global.selectBatchDetailsBatch) || emptyObject;
  const doesPrintSettingExist = !!useGetPrintSettingsForDocumentType(DocumentType.OrderSummary.printSettingKey);

  const onPrint = useCallback(() => {
    if (isOnBatchesGrid && fulfillmentPlanIds.length === 0 && fulfillmentPlanSetId) {
      dispatch(labelQuePrintOrderSummary(fulfillmentPlanSetId));
    }
    dispatch(printOrderSummary(fulfillmentPlanIds, !doesPrintSettingExist));
  }, [dispatch, fulfillmentPlanIds, fulfillmentPlanSetId, isOnBatchesGrid, doesPrintSettingExist]);

  return useMemo(
    () => ({
      isDisabled,
      onPrint,
    }),
    [isDisabled, onPrint],
  );
};
